export default __webpack_public_path__ + "images/DZ.fe6436e.png";